import { render } from "./schoolHome.vue?vue&type=template&id=efcf3b20&scoped=true"
import script from "./schoolHome.vue?vue&type=script&lang=js"
export * from "./schoolHome.vue?vue&type=script&lang=js"

import "./schoolHome.vue?vue&type=style&index=0&id=efcf3b20&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efcf3b20"]])

export default __exports__